import {Component, OnInit} from '@angular/core';
import {ApiService, Model} from "../../services/api.service";
import {HeaderDataService} from "../../services/header_data.service";
import {DateTimePeriodService} from "../../services/datetime_period.service";

@Component({
    selector: 'audit-history',
    templateUrl: './audit-history.component.html'
})
export class AuditHistoryComponent implements OnInit {

    audited_models: Model[];
    selected_models: Model[] = [];

    constructor(private api: ApiService,
                private headerDataService: HeaderDataService,
                private dateTimePeriodService: DateTimePeriodService) {
    }

    modelCompare = (a: Model, b: Model) => {
        return a.modelName == b.modelName;
    };

    ngOnInit() {
        this.headerDataService.add_refresh = true;
        this.dateTimePeriodService.show_time = true;
        this.dateTimePeriodService.show_timespan = false;
        this.headerDataService.show_dtp = true;

        this.headerDataService.title = 'Audit History';

        this.audited_models = this.api.mapApis.filter(item => item.audited).map(item => this.api[item.name]);


    }

    changedSelection() {
        console.log(this.selected_models)
    }

    private refresh() {

    }
}
